var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"manage__splash-modify--page"},[(_vm.getReady)?_c('SplashController'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }